import moment, { Moment } from "moment";

export interface PeriodDto {
  startAt: string;
  endAt: string;
}

export class Period {
  startAt: Moment;
  endAt: Moment;

  constructor(dto: PeriodDto) {
    this.startAt = moment(dto.startAt);
    this.endAt = moment(dto.endAt);
  }
}
